import { ReactElement } from "react";
import { PrimaryButton } from "../primaryButton/primaryButton";
import { SecondaryButton } from "../secondaryButton/secondaryButton";
import "./popup.scss";

export const Popup = (
  props: {
    class?: string;
    popupClass?: string;
    children?:ReactElement<any, any>;
    headline: string | undefined;
    text: string| undefined;
    buttonText?: string;
    buttonFunction: Function;
    buttonClose: Function;
    contentPopup?: boolean;
  }
) => {
  return (
    <div className={`gno-wrapper ${props.popupClass}`}>
      <div className={`gno-popup`} data-testid="popup">
        <p className={props.contentPopup ? "gno-h2-centered" : "gno-h2" }data-testid="headline">{props.headline}</p>
        <p className="gno-text">{props.text}</p>
        {props.children}
        <div className="button-spacing">
          {props.contentPopup ? null
        : <PrimaryButton
            text={props.buttonText}
            function={props.buttonFunction}
            negative={false}
        />
        }
          <SecondaryButton
            text="Schließen"
            function={props.buttonClose}
            negative={false}
          />
        </div>
      </div>
    </div>
  );
};
